export * from './Skeleton';
export { default } from './Skeleton';
//# sourceMappingURL=index.js.map